/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BanProjectOwnerDto } from '../../models/ban-project-owner-dto';
import { ProjectOwnerResponseAdminAdminDto } from '../../models/project-owner-response-admin-admin-dto';

export interface AdminProjectOwnersControllerBanProjectOwner$Params {
  id: string;
      body: BanProjectOwnerDto
}

export function adminProjectOwnersControllerBanProjectOwner(http: HttpClient, rootUrl: string, params: AdminProjectOwnersControllerBanProjectOwner$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectOwnerResponseAdminAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminProjectOwnersControllerBanProjectOwner.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectOwnerResponseAdminAdminDto>;
    })
  );
}

adminProjectOwnersControllerBanProjectOwner.PATH = '/admin/project-owners/{id}/ban';
